<template>
    <rest_select_list
        v-if="!isLoadList"
        :key="'rest_active_list'"
        :operationName="'active_rest'"
        :onlySelectLocations="true"
    />
</template>

<script>

import rest_select_list from "../RestSelectList.vue";
import {createHelpers} from "vuex-map-fields";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mAggregators} = createHelpers({
    getterType: 'aggregators/getAggregatorsField',
    mutationType: 'aggregators/updateAggregatorsField',
})

export default {
    name: "rest_active_page",
    emits: [],
    components: {
        rest_select_list,
    },
    data() {
        return {
            isLoadList: true,
        }
    },
    beforeMount() {
        this.$store.dispatch('user/STATE_LOAD_PAGE', true);
        this.$store.dispatch('aggregators/ACTIVE_AGGREGATORS_LIST', {
            user: this.user,
            onlySelectLocations: true,
            actionName: 'activeAggregatorsList'
        });
        EventBus.$on('active_aggregators_list', this.loadList);
    },
    mounted() {
        const contentClear = document.getElementById('content_remove');
        if (contentClear) {
            contentClear.parentNode.removeChild(contentClear);
        }
    },
    beforeUnmount() {
        EventBus.$off('active_aggregators_list', this.loadList);
    },
    methods: {
        loadList() {
            this.isLoadList = false;
            //EventBus.$emit('get_state_menu_main');
        },
    },
    computed: {
        ...mUser([
            'isLoadPage'
        ]),
    },
}
</script>
